import { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { Modal } from '../modal';
import { ModalFloatingHeader } from '../modal/new/modal-header';
import { Box, Flex } from '../grid';
import { P } from '../typography';

const StyledIframe = styled.iframe`
  border: none;
  width: 100%;
  height: ${({ height }) => height};
  background: white;
`;

const LoadingContainer = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${({ height }) => height};
  background: ${({ theme }) => theme.colors.grey50};
`;

const IFrameModal = ({ open, onClose, url, title }) => {
  const [loading, setLoading] = useState(true);

  // Reset loading/error state when modal opens with new URL
  useEffect(() => {
    if (open && url) {
      setLoading(true);
    }
  }, [open, url]);

  const handleIframeLoad = () => {
    setLoading(false);
  };

  const modalStyle = {
    justifyContent: 'flex-end',
  };

  if (!url) {
    return null;
  }

  return (
    <Modal
      open={open}
      onClose={onClose}
      style={modalStyle}
      wrapperStyle={{ maxHeight: '100vh' }}
      height="100%"
      width={{ xs: '100%', md: '600px' }}
      hideBottomDecal
      backgroundColor="white"
      isDividerHidden
      borderRadius="0px"
      header={
        <Box width="100%" position="relative">
          <ModalFloatingHeader handleClose={onClose} />

          <Flex width="100%" mt="45px" mb="30px" justifyContent="center">
            <img src="/static/images/brand/Uber_logo_2018.svg" style={{ height: '23px', width: '64px' }} alt="Uber" />
          </Flex>
        </Box>
      }
    >
      <Flex position="relative" flex="1">
        {loading && (
          <LoadingContainer flex="1">
            <P color="grey70">Loading...</P>
          </LoadingContainer>
        )}

        <StyledIframe
          src={url}
          title={title}
          flex="1"
          onLoad={handleIframeLoad}
          sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
          referrerPolicy="strict-origin-when-cross-origin"
          aria-label={`${title} content`}
          style={{
            display: loading ? 'none' : 'block',
          }}
        />
      </Flex>
    </Modal>
  );
};

IFrameModal.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

IFrameModal.defaultProps = {};

export { IFrameModal };
